var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress"},[_c('a-progress',{attrs:{"percent":_vm.$store.state.progress,"status":"active","show-info":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }